"use client"

import { useEffect } from 'react'

const DESKTOP = '(min-width: 1024px)'
const TOP_ZONE = 120
const STEP = 8

// Poniżej 1024 px chowa nagłówek przy przewijaniu w dół; wraca przy przewijaniu w górę i po wejściu fokusu do środka.
export default function HeaderScroll () {
    useEffect(() => {
        const header = document.getElementById('main-navb')
        if (!header) return

        const desktop = window.matchMedia(DESKTOP)
        let lastY = window.scrollY

        const show = () => header.removeAttribute('data-hidden')
        const onScroll = () => {
            const y = window.scrollY
            const menuOpen = header.querySelector('[aria-expanded="true"]')

            if (desktop.matches || y < TOP_ZONE || menuOpen) show()
            else if (y > lastY + STEP) header.setAttribute('data-hidden', '')
            else if (y < lastY - STEP) show()

            lastY = y
        }

        window.addEventListener('scroll', onScroll, { passive: true })
        header.addEventListener('focusin', show)
        desktop.addEventListener('change', show)

        return () => {
            window.removeEventListener('scroll', onScroll)
            header.removeEventListener('focusin', show)
            desktop.removeEventListener('change', show)
        }
    }, [])

    return null
}
